// Firebase configuration for NMAVillage
// Sharing Firebase project with Multi-Clarity

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyAKXB0qUTepCDlK35qECs-VeKG2NTMiH2I",
  authDomain: "navigational-mind-clarity.firebaseapp.com",
  projectId: "navigational-mind-clarity",
  storageBucket: "navigational-mind-clarity.firebasestorage.app",
  messagingSenderId: "785309890644",
  appId: "1:785309890644:web:8b598d4f61b6752efb55c1",
  measurementId: "G-Q13MSNKS7D"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;
